export const statusFilters = {
  all: 'All',
  active: 'Active',
  completed: 'Completed',
};
